





























































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalFinanceiroRegraDeCalculo from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalFinanceiroRegraDeCalculo.vue'
import ModalRegraValoresFixosIncluir from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalRegraValoresFixosIncluir.vue'
import FinanceiroTabelaRegrasProdutividade from '@/views/financeiro-tabela-regras-produtividade.vue'
import FinanceiroTabelaRegrasValoresFixos from '@/views/financeiro-tabela-regras-valores-fixos.vue'
import FinanceiroTabelaRegrasGarantiaMinima from '@/views/financeiro-tabela-regras-garantia-minima.vue'
import FinanceiroTabelaRegraGestao from '@/views/financeiro-tabela-regra-gestao.vue'
import FinanceiroTabelaRegrasAgendaGarantiaMinima from '@/views/financeiro-tabela-regras-agenda-garantia-minima.vue'
import ModalAddHospitalRegraGarantiaMinima from '@/components/RemuneracaoMedica/contratos/modais/ModalAddHospitalRegraGarantiaMinima.vue'
import ModalFinanceiroRegraGarantiaMinimaGlobal from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalFinanceiroRegraGarantiaMinimaGlobal.vue'
import ModalRegrasAgendaGarantiaMinima from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalRegrasAgendaGarantiaMinima.vue'
import ModalRegraGestaoIncluir from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalRegraGestaoIncluir.vue'
import FinanceiroTabelaIndicacao from '@/views/financeiro-tabela-indicacao.vue'
import ModalFinanceiroRegraIndicacao from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalFinanceiroRegraIndicacao.vue'
import ModalRegraTeto from '@/components/RemuneracaoMedica/RegrasDeCalculo/components/ModalRegraTeto.vue'
import FinanceiroTabelaRegrasTeto from '@/views/financeiro-tabela-regras-teto.vue'

@Component({
  components: {
    ModalFinanceiroRegraDeCalculo,
    ModalRegraValoresFixosIncluir,
    FinanceiroTabelaRegrasProdutividade,
    FinanceiroTabelaRegrasValoresFixos,
    FinanceiroTabelaRegrasGarantiaMinima,
    FinanceiroTabelaRegraGestao,
    FinanceiroTabelaRegrasAgendaGarantiaMinima,
    ModalAddHospitalRegraGarantiaMinima,
    ModalFinanceiroRegraGarantiaMinimaGlobal,
    ModalRegrasAgendaGarantiaMinima,
    ModalRegraGestaoIncluir,
    FinanceiroTabelaIndicacao,
    ModalFinanceiroRegraIndicacao,
    ModalRegraTeto,
    FinanceiroTabelaRegrasTeto,
  },
})
export default class ViewFinanceiroRegrasProfissional extends Vue {
  loadAdicionarRegraDeCalculo: boolean = false
  pageAuthorizedGarantia: boolean = false
  pageAuthorizedGestao: boolean = false
  pageAuthorizedAgendaGarantia: boolean = false
  pageAuthorizedIndicacao: boolean = false
  pageAuthorizedRegraTeto: boolean = false
  showIntermediateModal = false
  activeTab: string = 'produtividade'

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get temGarantiaMinima() {
    return this.pageAuthorizedGarantia
  }

  get temGestaoProdutividade() {
    return this.pageAuthorizedGestao
  }

  get temIndicacao() {
    return this.pageAuthorizedIndicacao
  }

  get temRegraTeto() {
    return this.pageAuthorizedRegraTeto
  }

  get temAgendaGarantia() {
    return this.pageAuthorizedAgendaGarantia
  }

  get isAbaRegraGestao() {
    return this.activeTab === 'regra-gestao'
  }

  get showModalFinanceiroRegraDeCalculo() { return this.getRegrasDeCalculoStore.modal.regraDeCalculo }
  get showModalRegraValoresFixosIncluir() { return this.getRegrasDeCalculoStore.modal.valoresFixosIncluir }
  get showModalGarantiaMinimaAddHospital() { return this.getRegrasDeCalculoStore.modal.regraGarantiaMinimaAddHospital }
  get showModalRegraDeCalculoGarantiaMinima() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGarantiaMinima }
  get showModalIndicacao() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoIndicacao }
  get showModalRegraAgendaGarantiaMinima() { return this.getRegrasDeCalculoStore.modal.regraAgendaGarantiaMinima }
  get showModalRegraGestaoIncluir() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGestao }
  get showModalRegraDeCalculo() { return this.getRegrasDeCalculoStore.modal.regraDeCalculo }

  filtrarRegrasDeGestao() {
    const paginacaoAtual = this.getRegrasDeCalculoStore.paginacaoRegrasValorFixo
    this.getRegrasDeCalculoStore.getRegrasGestao(paginacaoAtual)
  }

  openModalIntermediate() {
    this.showIntermediateModal = true
  }

  adicionarRegraProdutividade() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setMode('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculo', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  adicionarRegraValorFixo() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setModeModalRegraValoresFixos('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'valoresFixosIncluir', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  adicionarRegraGarantiaMinima() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setMode('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGarantiaMinima', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  adicionarIndicacao() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setModeIndicacao('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoIndicacao', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  adicionarRegraGestao() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setModeModalRegraGestao('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGestao', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  adicionarRegraAgendaGarantiaMinima() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setModeModalAgendaGarantiaMinima('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraAgendaGarantiaMinima', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  adicionarRegraDeTeto() {
    this.loadAdicionarRegraDeCalculo = true
    this.getRegrasDeCalculoStore.setMode('CREATE')
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeTeto', value: true })
    this.showIntermediateModal = false
    this.loadAdicionarRegraDeCalculo = false
  }

  async mounted() {
    this.pageAuthorizedGarantia = this.$user.profile.pageAuthorized.includes('financeiro-garantia-minima-global')
    this.pageAuthorizedGestao = this.$user.profile.pageAuthorized.includes('financeiro-calculo-gestao-produtividade')
    this.pageAuthorizedAgendaGarantia = this.$user.profile.pageAuthorized.includes('financeiro-agenda-minima-garantia-periodo')
    this.pageAuthorizedIndicacao = this.$user.profile.pageAuthorized.includes('financeiro-calculo-indicacao')
    this.pageAuthorizedRegraTeto = this.$user.profile.pageAuthorized.includes('financeiro-calculo-teto-global')
    this.getRegrasDeCalculoStore.getFontesPagadoras()
    this.getRegrasDeCalculoStore.getLocaisExecucao()
    this.getRegrasDeCalculoStore.getGestores()
    
    if(this.activeTab === 'produtividade' || this.activeTab === 'agenda-garantia-minima') {
      await this.getRegrasDeCalculoStore.getValorReferenciaTipos()
      await this.getRegrasDeCalculoStore.getValorDeReferenciaEnum()
      await this.getRegrasDeCalculoStore.getTabelaPrecoAll()
      await this.getRegrasDeCalculoStore.getTipos()
      await this.getRegrasDeCalculoStore.getValoresReferencia()
    }
  }

  get regrasDisponiveis() {
    return [
      {
        title: 'REGRA DE PRODUTIVIDADE',
        action: this.adicionarRegraProdutividade,
        permission: null,
      },
      {
        title: 'REGRA DE VALOR FIXO',
        action: this.adicionarRegraValorFixo,
        permission: null,
      },
      {
        title: 'REGRA DE GARANTIA MÍNIMA GLOBAL',
        action: this.adicionarRegraGarantiaMinima,
        permission: 'garantia',
      },
      {
        title: 'GESTÃO POR PRODUTIVIDADE',
        action: this.adicionarRegraGestao,
        permission: 'gestao',
      },
      {
        title: 'REGRA AGENDA GARANTIA MINIMA',
        action: this.adicionarRegraAgendaGarantiaMinima,
        permission: 'agenda',
      },
      {
        title: 'REGRA DE INDICAÇÃO',
        action: this.adicionarIndicacao,
        permission: 'indicacao',
      },
      {
        title: 'REGRA DE TETO',
        action: this.adicionarRegraDeTeto,
        permission: 'teto',
      },
    ]
  }

  get regrasFiltradas() {
    return this.regrasDisponiveis.filter(regra => {
      if (!regra.permission) return true
      if (regra.permission === 'garantia') return this.temGarantiaMinima
      if (regra.permission === 'agenda') return this.temAgendaGarantia
      if (regra.permission === 'gestao') return this.temGestaoProdutividade
      if (regra.permission === 'indicacao') return this.temIndicacao
      if (regra.permission === 'teto') return this.temRegraTeto
      return false
    })
  }
}
